import { dispatchCustomEvent, getWindowSize, throttle } from '../../tools/helpers';
import { CONFIG, BREAKPOINTS } from '../config';

let eventHandlerResize = null;

class ResizeHandler {
  constructor() {
    // resize
    this.timeResize = 70;

    this.timeViewport = 70;

    // state
    this.currentViewport = null;
  }

  init() {
    // set initial viewport
    this.getCurrentViewport();

    // add handlers
    this.initEventResize();
  }


  /**
   * RESIZE EVENT
   */

  initEventResize() {
    window.addEventListener('resize', () => {
      // resize handling
      throttle(this.handleEventResize(), this.timeResize);

      // viewport change handling
      throttle(this.handleEventViewportChangeWrapper(), this.timeViewport);
    });
  }

  handleEventResize() {
    // define custom event for browser resize
    dispatchCustomEvent(
      CONFIG.events.RESIZE,
      {},
    );
  }


  /**
   * VIEWPORT CHANGE
   */

  handleEventViewportChangeWrapper() {
    const windowWidth = getWindowSize().width;

    this.handleEventViewportChange(windowWidth);
  }

  handleEventViewportChange(windowWidth) {
    const viewportKey = this.checkViewport();

    // check if viewport changed
    if (viewportKey !== this.currentViewport) {
      this.currentViewport = viewportKey;
      // define custom event for viewport-change
      dispatchCustomEvent(
        CONFIG.events.VIEWPORT_CHANGED,
        {
          viewport: viewportKey,
          width: windowWidth,
        },
      );
    }
  }

  /**
   * HELPERS
   */

  checkViewport() {
    for (const viewport of CONFIG.viewports) {
      if (window.matchMedia(`screen and (max-width: ${viewport.width}px)`).matches) {
        return viewport.name;
      }
    }
    return BREAKPOINTS.large;
  }

  getCurrentViewport() {
    if (this.currentViewport === null) {
      // set initial viewport
      this.currentViewport = this.checkViewport();
    }
    return this.currentViewport;
  }

  getViewportInfo(currentViewport) {
    const checkViewport = currentViewport || this.getCurrentViewport();

    for (const viewport of CONFIG.viewports) {
      if (checkViewport === viewport.name) {
        return {
          viewport: viewport.name,
          width: viewport.width,
        };
      }
    }
    return null;
  }
}

// prepare singleton behavior
if (!eventHandlerResize) {
  eventHandlerResize = new ResizeHandler();
  eventHandlerResize.init();
}

export default () => eventHandlerResize;



// WEBPACK FOOTER //
// ./src/javascript/main/ResizeHandler/index.js